// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.login_pg_container {
  font-family: 'Manrope', sans-serif;
  display: flex;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
}
.login_pg_left {
  position: relative;
  flex: 0 0 44%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
 background-image: linear-gradient(to top, rgb(100, 28, 100), rgb(255, 255, 255),white);  overflow: hidden;
}

.login_pg_left::before {
  content: '';
  position: absolute;
  inset: -20%;
  background-image: radial-gradient(#ffae00 1.4px, transparent 1.4px);
  background-size: 30px 30px;
  opacity: 0.10;
  animation: dotDrift 30s linear infinite;
  pointer-events: none;
}

.login_pg_left::after {
  content: '';
  position: absolute;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(241, 171, 73, 0.829) 0%, rgba(245, 168, 60, 0) 70%);
  animation: haloBreathe 5s ease-in-out infinite;
  pointer-events: none;
}

@keyframes dotDrift {
  0% { background-position: 0 0; }
  100% { background-position: 260px 130px; }
}

@keyframes haloBreathe {
  0%, 100% { transform: scale(1); opacity: 0.75; }
  50% { transform: scale(1.22); opacity: 1; }
}
.login_pg_logo_row {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 26px 32px;
  border-radius: 18px;
}
.login_pg_logo_side_img,
.login_pg_logo_img {
  border-radius: 12px;
  object-fit: contain;
  background: rgb(255, 255, 255);
  padding: 6px;
  height: 208px;
  width: 208px;
}


.login_pg_right {
  flex: 1 1;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;
  overflow-y: auto;
}

.login_pg_form_wrap {
  width: 100%;
  max-width: 400px;
  opacity: 0;
  animation: fadeInUp 0.6s ease 0.1s forwards;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(18px); }
  to { opacity: 1; transform: translateY(0); }
}

.login_pg_title {
  font-family: 'Manrope', sans-serif;
  font-weight: 800;
  font-size: 27px;
  color: #171b2e;
  margin: 0 0 6px;
  letter-spacing: -0.3px;
}

.login_pg_subtitle {
  font-family: 'Manrope', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #6b7089;
  margin: 0 0 30px;
  line-height: 1.5;
}

.login_pg_form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.login_pg_field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  opacity: 0;
  animation: fadeInUp 0.5s ease forwards;
}

.login_pg_field:nth-of-type(1) { animation-delay: 0.15s; }
.login_pg_field:nth-of-type(2) { animation-delay: 0.22s; }

.login_pg_label {
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 13.5px;
  color: #262b45;
}

.login_pg_required {
  color: #e0633f;
  font-weight: 700;
}

.login_pg_input {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 14.5px;
  color: #1b1f33;
  padding: 13px 15px;
  width: 100%;
  border-radius: 11px;
  border: 1.5px solid #e6e3dc;
  background: #ffffff;
  outline: none;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.15s ease;
}

.login_pg_input::placeholder {
  color: #a7abc0;
  font-weight: 400;
}

.login_pg_input:hover {
  border-color: #d4d0c6;
}

.login_pg_input:focus {
  border-color: #f5a83c;
  box-shadow: 0 0 0 4px rgba(245, 168, 60, 0.16);
  transform: translateY(-1px);
}

.login_pg_error_text {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 12.5px;
  color: #d8455c;
  animation: shakeIn 0.35s ease;
}

@keyframes shakeIn {
  0% { opacity: 0; transform: translateX(-6px); }
  40% { transform: translateX(4px); }
  70% { transform: translateX(-2px); }
  100% { opacity: 1; transform: translateX(0); }
}

.login_pg_password_wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.login_pg_input_password {
  padding-right: 46px;
}

.login_pg_eye_btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8b8fa3;
  cursor: pointer;
  border-radius: 6px;
  transition: color 0.2s ease, transform 0.2s ease, background 0.2s ease;
}

.login_pg_eye_btn:hover {
  color: #f5a83c;
  background: rgba(245, 168, 60, 0.10);
  transform: translateY(-50%) scale(1.08);
}

.login_pg_options_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  opacity: 0;
  animation: fadeInUp 0.5s ease 0.3s forwards;
}

.login_pg_checkbox_row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.login_pg_checkbox {
  appearance: none;
  -webkit-appearance: none;
  width: 19px;
  height: 19px;
  min-width: 19px;
  border-radius: 6px;
  border: 1.6px solid #d4d0c6;
  background: #ffffff;
  cursor: pointer;
  position: relative;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
}

.login_pg_checkbox:checked {
  background: #f5a83c;
  border-color: #f5a83c;
  transform: scale(1.05);
}

.login_pg_checkbox:checked::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid #171b2e;
  border-width: 0 2px 2px 0;
  transform: rotate(40deg);
}

.login_pg_checkbox_label {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13.5px;
  color: #4b5165;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.login_pg_forgot_link {
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #024200;
  text-decoration: none;
  position: relative;
  transition: color 0.2s ease;
}

.login_pg_forgot_link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 0%;
  height: 1.5px;
  background: #d8792e;
  transition: width 0.25s ease;
}

.login_pg_forgot_link:hover {
  color: #b56010;
}

.login_pg_forgot_link:hover::after {
  width: 100%;
}

.login_pg_submit_btn {
  font-family: 'Manrope', sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #171b2e;
  padding: 14px 20px;
  width: 100%;
  border: none;
  border-radius: 11px;
  background: #f5a83c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
  overflow: hidden;
  margin-top: 4px;
  opacity: 0;
  animation: fadeInUp 0.5s ease 0.38s forwards;
  transition: background 0.25s ease, transform 0.15s ease, box-shadow 0.25s ease;
}

.login_pg_submit_btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -60%;
  width: 50%;
  height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.45), transparent);
  transform: skewX(-20deg);
  transition: left 0.6s ease;
}

.login_pg_submit_btn:hover:not(:disabled) {
  background: #e89323;
  box-shadow: 0 8px 20px rgba(245, 168, 60, 0.35);
  transform: translateY(-2px);
}

.login_pg_submit_btn:hover:not(:disabled)::before {
  left: 120%;
}

.login_pg_submit_btn:active:not(:disabled) {
  transform: translateY(0);
}

.login_pg_submit_btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login_pg_arrow {
  display: inline-block;
  transition: transform 0.25s ease;
}

.login_pg_submit_btn:hover:not(:disabled) .login_pg_arrow {
  transform: translateX(4px);
}

.login_pg_signup_text {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13.5px;
  color: #6b7089;
  text-align: center;
  margin: 6px 0 0;
  opacity: 0;
  animation: fadeInUp 0.5s ease 0.46s forwards;
}

.login_pg_signup_link {
  font-weight: 700;
 color: #024200;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  transition: color 0.2s ease;
}

.login_pg_signup_link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 0%;
  height: 1.5px;
  background: #d8792e;
  transition: width 0.25s ease;
}

.login_pg_signup_link:hover {
  color: #b56010;
}

.login_pg_signup_link:hover::after {
  width: 100%;
}

/* ============================================================
   RESPONSIVE — tablet
   ============================================================ */

@media (max-width: 1024px) {
  .login_pg_left {
    flex: 0 0 40%;
  }

  .login_pg_right {
    padding: 40px 28px;
  }
}

@media (max-width: 860px) {
  .login_pg_container {
    flex-direction: column;
  }

  .login_pg_left {
    flex: none;
    min-height: 220px;
    padding: 36px 24px;
  }

  .login_pg_left::before {
    animation-duration: 40s;
  }

  .login_pg_logo_row {
    padding: 20px 26px;
  }

  .login_pg_right {
    min-height: auto;
    padding: 40px 24px 56px;
  }
}

/* ============================================================
   RESPONSIVE — mobile
   ============================================================ */

@media (max-width: 560px) {
  .login_pg_left {
    min-height: 180px;
    padding: 28px 20px;
  }

  .login_pg_logo_side_img,
  .login_pg_logo_img {
    width: 100px;
    height: 100px;
    margin-top: 30px;
  }

  .login_pg_logo_row {
    gap: 20px;
    padding: 16px 20px;
  }

  .login_pg_right {
    padding: 32px 18px 48px;
  }

  .login_pg_title {
    font-size: 23px;
  }

  .login_pg_form {
    gap: 15px;
  }

  .login_pg_input {
    padding: 12px 13px;
    font-size: 14px;
  }

  .login_pg_options_row {
    flex-direction: row;
    justify-content: space-between;
  }

  .login_pg_submit_btn {
    padding: 13px 18px;
    font-size: 14.5px;
  }
}

@media (max-width: 360px) {
  .login_pg_options_row {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

/* ============================================================
   Respect reduced motion
   ============================================================ */

@media (prefers-reduced-motion: reduce) {
  .login_pg_left::before,
  .login_pg_left::after,
  .login_pg_logo_row,
  .login_pg_form_wrap,
  .login_pg_field,
  .login_pg_options_row,
  .login_pg_submit_btn,
  .login_pg_signup_text {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Auth/Login/LoginPage.css"],"names":[],"mappings":";AACA;EACE,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;CACxB,sFAAsF,GAAG,gBAAgB;AAC1G;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,mEAAmE;EACnE,0BAA0B;EAC1B,aAAa;EACb,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,4FAA4F;EAC5F,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,gCAAgC,EAAE;AAC3C;;AAEA;EACE,WAAW,mBAAmB,EAAE,aAAa,EAAE;EAC/C,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;;AAGA;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,sCAAsC;AACxC;;AAEA,iCAAiC,sBAAsB,EAAE;AACzD,iCAAiC,sBAAsB,EAAE;;AAEzD;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,KAAK,UAAU,EAAE,2BAA2B,EAAE;EAC9C,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sEAAsE;AACxE;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,4CAA4C;EAC5C,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,wFAAwF;EACxF,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;CACjB,cAAc;EACb,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;;;;;;;;IAQE,0BAA0B;IAC1B,qBAAqB;IACrB,0BAA0B;EAC5B;AACF","sourcesContent":["\n.login_pg_container {\n  font-family: 'Manrope', sans-serif;\n  display: flex;\n  min-height: 100vh;\n  width: 100%;\n  overflow: hidden;\n}\n.login_pg_left {\n  position: relative;\n  flex: 0 0 44%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n background-image: linear-gradient(to top, rgb(100, 28, 100), rgb(255, 255, 255),white);  overflow: hidden;\n}\n\n.login_pg_left::before {\n  content: '';\n  position: absolute;\n  inset: -20%;\n  background-image: radial-gradient(#ffae00 1.4px, transparent 1.4px);\n  background-size: 30px 30px;\n  opacity: 0.10;\n  animation: dotDrift 30s linear infinite;\n  pointer-events: none;\n}\n\n.login_pg_left::after {\n  content: '';\n  position: absolute;\n  width: 420px;\n  height: 420px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(241, 171, 73, 0.829) 0%, rgba(245, 168, 60, 0) 70%);\n  animation: haloBreathe 5s ease-in-out infinite;\n  pointer-events: none;\n}\n\n@keyframes dotDrift {\n  0% { background-position: 0 0; }\n  100% { background-position: 260px 130px; }\n}\n\n@keyframes haloBreathe {\n  0%, 100% { transform: scale(1); opacity: 0.75; }\n  50% { transform: scale(1.22); opacity: 1; }\n}\n.login_pg_logo_row {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 26px 32px;\n  border-radius: 18px;\n}\n.login_pg_logo_side_img,\n.login_pg_logo_img {\n  border-radius: 12px;\n  object-fit: contain;\n  background: rgb(255, 255, 255);\n  padding: 6px;\n  height: 208px;\n  width: 208px;\n}\n\n\n.login_pg_right {\n  flex: 1;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 32px;\n  overflow-y: auto;\n}\n\n.login_pg_form_wrap {\n  width: 100%;\n  max-width: 400px;\n  opacity: 0;\n  animation: fadeInUp 0.6s ease 0.1s forwards;\n}\n\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(18px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.login_pg_title {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 800;\n  font-size: 27px;\n  color: #171b2e;\n  margin: 0 0 6px;\n  letter-spacing: -0.3px;\n}\n\n.login_pg_subtitle {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #6b7089;\n  margin: 0 0 30px;\n  line-height: 1.5;\n}\n\n.login_pg_form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.login_pg_field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  opacity: 0;\n  animation: fadeInUp 0.5s ease forwards;\n}\n\n.login_pg_field:nth-of-type(1) { animation-delay: 0.15s; }\n.login_pg_field:nth-of-type(2) { animation-delay: 0.22s; }\n\n.login_pg_label {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 600;\n  font-size: 13.5px;\n  color: #262b45;\n}\n\n.login_pg_required {\n  color: #e0633f;\n  font-weight: 700;\n}\n\n.login_pg_input {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 500;\n  font-size: 14.5px;\n  color: #1b1f33;\n  padding: 13px 15px;\n  width: 100%;\n  border-radius: 11px;\n  border: 1.5px solid #e6e3dc;\n  background: #ffffff;\n  outline: none;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.15s ease;\n}\n\n.login_pg_input::placeholder {\n  color: #a7abc0;\n  font-weight: 400;\n}\n\n.login_pg_input:hover {\n  border-color: #d4d0c6;\n}\n\n.login_pg_input:focus {\n  border-color: #f5a83c;\n  box-shadow: 0 0 0 4px rgba(245, 168, 60, 0.16);\n  transform: translateY(-1px);\n}\n\n.login_pg_error_text {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 500;\n  font-size: 12.5px;\n  color: #d8455c;\n  animation: shakeIn 0.35s ease;\n}\n\n@keyframes shakeIn {\n  0% { opacity: 0; transform: translateX(-6px); }\n  40% { transform: translateX(4px); }\n  70% { transform: translateX(-2px); }\n  100% { opacity: 1; transform: translateX(0); }\n}\n\n.login_pg_password_wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.login_pg_input_password {\n  padding-right: 46px;\n}\n\n.login_pg_eye_btn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #8b8fa3;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: color 0.2s ease, transform 0.2s ease, background 0.2s ease;\n}\n\n.login_pg_eye_btn:hover {\n  color: #f5a83c;\n  background: rgba(245, 168, 60, 0.10);\n  transform: translateY(-50%) scale(1.08);\n}\n\n.login_pg_options_row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  opacity: 0;\n  animation: fadeInUp 0.5s ease 0.3s forwards;\n}\n\n.login_pg_checkbox_row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.login_pg_checkbox {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 19px;\n  height: 19px;\n  min-width: 19px;\n  border-radius: 6px;\n  border: 1.6px solid #d4d0c6;\n  background: #ffffff;\n  cursor: pointer;\n  position: relative;\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;\n}\n\n.login_pg_checkbox:checked {\n  background: #f5a83c;\n  border-color: #f5a83c;\n  transform: scale(1.05);\n}\n\n.login_pg_checkbox:checked::after {\n  content: '';\n  position: absolute;\n  left: 5px;\n  top: 1px;\n  width: 5px;\n  height: 9px;\n  border: solid #171b2e;\n  border-width: 0 2px 2px 0;\n  transform: rotate(40deg);\n}\n\n.login_pg_checkbox_label {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 500;\n  font-size: 13.5px;\n  color: #4b5165;\n  cursor: pointer;\n  user-select: none;\n}\n\n.login_pg_forgot_link {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 600;\n  font-size: 13px;\n  color: #024200;\n  text-decoration: none;\n  position: relative;\n  transition: color 0.2s ease;\n}\n\n.login_pg_forgot_link::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  width: 0%;\n  height: 1.5px;\n  background: #d8792e;\n  transition: width 0.25s ease;\n}\n\n.login_pg_forgot_link:hover {\n  color: #b56010;\n}\n\n.login_pg_forgot_link:hover::after {\n  width: 100%;\n}\n\n.login_pg_submit_btn {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #171b2e;\n  padding: 14px 20px;\n  width: 100%;\n  border: none;\n  border-radius: 11px;\n  background: #f5a83c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  position: relative;\n  overflow: hidden;\n  margin-top: 4px;\n  opacity: 0;\n  animation: fadeInUp 0.5s ease 0.38s forwards;\n  transition: background 0.25s ease, transform 0.15s ease, box-shadow 0.25s ease;\n}\n\n.login_pg_submit_btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -60%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.45), transparent);\n  transform: skewX(-20deg);\n  transition: left 0.6s ease;\n}\n\n.login_pg_submit_btn:hover:not(:disabled) {\n  background: #e89323;\n  box-shadow: 0 8px 20px rgba(245, 168, 60, 0.35);\n  transform: translateY(-2px);\n}\n\n.login_pg_submit_btn:hover:not(:disabled)::before {\n  left: 120%;\n}\n\n.login_pg_submit_btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login_pg_submit_btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.login_pg_arrow {\n  display: inline-block;\n  transition: transform 0.25s ease;\n}\n\n.login_pg_submit_btn:hover:not(:disabled) .login_pg_arrow {\n  transform: translateX(4px);\n}\n\n.login_pg_signup_text {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 500;\n  font-size: 13.5px;\n  color: #6b7089;\n  text-align: center;\n  margin: 6px 0 0;\n  opacity: 0;\n  animation: fadeInUp 0.5s ease 0.46s forwards;\n}\n\n.login_pg_signup_link {\n  font-weight: 700;\n color: #024200;\n  text-decoration: none;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.2s ease;\n}\n\n.login_pg_signup_link::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  width: 0%;\n  height: 1.5px;\n  background: #d8792e;\n  transition: width 0.25s ease;\n}\n\n.login_pg_signup_link:hover {\n  color: #b56010;\n}\n\n.login_pg_signup_link:hover::after {\n  width: 100%;\n}\n\n/* ============================================================\n   RESPONSIVE — tablet\n   ============================================================ */\n\n@media (max-width: 1024px) {\n  .login_pg_left {\n    flex: 0 0 40%;\n  }\n\n  .login_pg_right {\n    padding: 40px 28px;\n  }\n}\n\n@media (max-width: 860px) {\n  .login_pg_container {\n    flex-direction: column;\n  }\n\n  .login_pg_left {\n    flex: none;\n    min-height: 220px;\n    padding: 36px 24px;\n  }\n\n  .login_pg_left::before {\n    animation-duration: 40s;\n  }\n\n  .login_pg_logo_row {\n    padding: 20px 26px;\n  }\n\n  .login_pg_right {\n    min-height: auto;\n    padding: 40px 24px 56px;\n  }\n}\n\n/* ============================================================\n   RESPONSIVE — mobile\n   ============================================================ */\n\n@media (max-width: 560px) {\n  .login_pg_left {\n    min-height: 180px;\n    padding: 28px 20px;\n  }\n\n  .login_pg_logo_side_img,\n  .login_pg_logo_img {\n    width: 100px;\n    height: 100px;\n    margin-top: 30px;\n  }\n\n  .login_pg_logo_row {\n    gap: 20px;\n    padding: 16px 20px;\n  }\n\n  .login_pg_right {\n    padding: 32px 18px 48px;\n  }\n\n  .login_pg_title {\n    font-size: 23px;\n  }\n\n  .login_pg_form {\n    gap: 15px;\n  }\n\n  .login_pg_input {\n    padding: 12px 13px;\n    font-size: 14px;\n  }\n\n  .login_pg_options_row {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .login_pg_submit_btn {\n    padding: 13px 18px;\n    font-size: 14.5px;\n  }\n}\n\n@media (max-width: 360px) {\n  .login_pg_options_row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n}\n\n/* ============================================================\n   Respect reduced motion\n   ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .login_pg_left::before,\n  .login_pg_left::after,\n  .login_pg_logo_row,\n  .login_pg_form_wrap,\n  .login_pg_field,\n  .login_pg_options_row,\n  .login_pg_submit_btn,\n  .login_pg_signup_text {\n    animation: none !important;\n    opacity: 1 !important;\n    transform: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
